import { memo } from 'react';

import type { ContentBlock } from '@/types/newsService';
import { MarkdownText } from './MarkdownText';

interface Props {
  block: ContentBlock;
}

export const ListBlock = memo(function ListBlock({ block }: Props) {
  if (!block.items || block.items.length === 0) return null;

  const isOrdered = block.style === 'ordered';

  return (
    <div className="my-2">
      {block.items.map((item, i) => (
        <div key={i} className="mb-1.5 flex pr-4">
          <span className="w-6 font-bold text-brand">{isOrdered ? `${i + 1}.` : '•'}</span>
          <MarkdownText className="flex-1 text-base leading-6 text-fg">{item}</MarkdownText>
        </div>
      ))}
    </div>
  );
});
